export default __webpack_public_path__ + "static/media/Create-documentation.4766c509.md";